module.exports = __webpack_public_path__ + "static/media/211231_GKC_Cam_01.c3803104.webp";